/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UsersRouteImport } from './routes/users'
import { Route as UsageStatisticsRouteImport } from './routes/usage-statistics'
import { Route as TestingRouteImport } from './routes/testing'
import { Route as RecipesRouteImport } from './routes/recipes'
import { Route as IngredientsRouteImport } from './routes/ingredients'
import { Route as IndexRouteImport } from './routes/index'
import { Route as UtilsIndexRouteImport } from './routes/utils.index'
import { Route as UsersIndexRouteImport } from './routes/users.index'
import { Route as SettingsIndexRouteImport } from './routes/settings.index'
import { Route as RecipesIndexRouteImport } from './routes/recipes.index'
import { Route as PhotosIndexRouteImport } from './routes/photos.index'
import { Route as MealSimulationIndexRouteImport } from './routes/meal-simulation.index'
import { Route as FoodgroupsIndexRouteImport } from './routes/foodgroups.index'
import { Route as FoodRestrictionsIndexRouteImport } from './routes/food-restrictions.index'
import { Route as UsageStatisticsPreferencesRouteImport } from './routes/usage-statistics.preferences'
import { Route as UsageStatisticsEngagementRouteImport } from './routes/usage-statistics.engagement'
import { Route as RecipesNewRouteImport } from './routes/recipes_.new'
import { Route as RecipesRecipeIdRouteImport } from './routes/recipes_.$recipeId'
import { Route as RecipesStatsRouteImport } from './routes/recipes.stats'
import { Route as IngredientsFcdbRouteImport } from './routes/ingredients.fcdb'
import { Route as IngredientsDisplaynamesRouteImport } from './routes/ingredients.displaynames'
import { Route as FoodgroupsGroupIdRouteImport } from './routes/foodgroups.$groupId'
import { Route as FoodRestrictionsNewRouteImport } from './routes/food-restrictions.new'
import { Route as FoodRestrictionsRestrictionIdRouteImport } from './routes/food-restrictions.$restrictionId'
import { Route as UsersDbcontextIdRouteImport } from './routes/users.$dbcontext.$id'
import { Route as RecipesDuplicateRecipeIdRouteImport } from './routes/recipes_.duplicate.$recipeId'
import { Route as RecipesRecipeIdPhotosRouteImport } from './routes/recipes_.$recipeId_.photos'
import { Route as IngredientsFcdbIngIdRouteImport } from './routes/ingredients_.fcdb_.$ingId'
import { Route as IngredientsDisplaynamesNewRouteImport } from './routes/ingredients_.displaynames_.new'
import { Route as IngredientsDisplaynamesIngIdRouteImport } from './routes/ingredients_.displaynames_.$ingId'

const UsersRoute = UsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => rootRouteImport,
} as any)
const UsageStatisticsRoute = UsageStatisticsRouteImport.update({
  id: '/usage-statistics',
  path: '/usage-statistics',
  getParentRoute: () => rootRouteImport,
} as any)
const TestingRoute = TestingRouteImport.update({
  id: '/testing',
  path: '/testing',
  getParentRoute: () => rootRouteImport,
} as any)
const RecipesRoute = RecipesRouteImport.update({
  id: '/recipes',
  path: '/recipes',
  getParentRoute: () => rootRouteImport,
} as any)
const IngredientsRoute = IngredientsRouteImport.update({
  id: '/ingredients',
  path: '/ingredients',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const UtilsIndexRoute = UtilsIndexRouteImport.update({
  id: '/utils/',
  path: '/utils/',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersIndexRoute = UsersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => UsersRoute,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => rootRouteImport,
} as any)
const RecipesIndexRoute = RecipesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => RecipesRoute,
} as any)
const PhotosIndexRoute = PhotosIndexRouteImport.update({
  id: '/photos/',
  path: '/photos/',
  getParentRoute: () => rootRouteImport,
} as any)
const MealSimulationIndexRoute = MealSimulationIndexRouteImport.update({
  id: '/meal-simulation/',
  path: '/meal-simulation/',
  getParentRoute: () => rootRouteImport,
} as any)
const FoodgroupsIndexRoute = FoodgroupsIndexRouteImport.update({
  id: '/foodgroups/',
  path: '/foodgroups/',
  getParentRoute: () => rootRouteImport,
} as any)
const FoodRestrictionsIndexRoute = FoodRestrictionsIndexRouteImport.update({
  id: '/food-restrictions/',
  path: '/food-restrictions/',
  getParentRoute: () => rootRouteImport,
} as any)
const UsageStatisticsPreferencesRoute =
  UsageStatisticsPreferencesRouteImport.update({
    id: '/preferences',
    path: '/preferences',
    getParentRoute: () => UsageStatisticsRoute,
  } as any)
const UsageStatisticsEngagementRoute =
  UsageStatisticsEngagementRouteImport.update({
    id: '/engagement',
    path: '/engagement',
    getParentRoute: () => UsageStatisticsRoute,
  } as any)
const RecipesNewRoute = RecipesNewRouteImport.update({
  id: '/recipes_/new',
  path: '/recipes/new',
  getParentRoute: () => rootRouteImport,
} as any)
const RecipesRecipeIdRoute = RecipesRecipeIdRouteImport.update({
  id: '/recipes_/$recipeId',
  path: '/recipes/$recipeId',
  getParentRoute: () => rootRouteImport,
} as any)
const RecipesStatsRoute = RecipesStatsRouteImport.update({
  id: '/stats',
  path: '/stats',
  getParentRoute: () => RecipesRoute,
} as any)
const IngredientsFcdbRoute = IngredientsFcdbRouteImport.update({
  id: '/fcdb',
  path: '/fcdb',
  getParentRoute: () => IngredientsRoute,
} as any)
const IngredientsDisplaynamesRoute = IngredientsDisplaynamesRouteImport.update({
  id: '/displaynames',
  path: '/displaynames',
  getParentRoute: () => IngredientsRoute,
} as any)
const FoodgroupsGroupIdRoute = FoodgroupsGroupIdRouteImport.update({
  id: '/foodgroups/$groupId',
  path: '/foodgroups/$groupId',
  getParentRoute: () => rootRouteImport,
} as any)
const FoodRestrictionsNewRoute = FoodRestrictionsNewRouteImport.update({
  id: '/food-restrictions/new',
  path: '/food-restrictions/new',
  getParentRoute: () => rootRouteImport,
} as any)
const FoodRestrictionsRestrictionIdRoute =
  FoodRestrictionsRestrictionIdRouteImport.update({
    id: '/food-restrictions/$restrictionId',
    path: '/food-restrictions/$restrictionId',
    getParentRoute: () => rootRouteImport,
  } as any)
const UsersDbcontextIdRoute = UsersDbcontextIdRouteImport.update({
  id: '/$dbcontext/$id',
  path: '/$dbcontext/$id',
  getParentRoute: () => UsersRoute,
} as any)
const RecipesDuplicateRecipeIdRoute =
  RecipesDuplicateRecipeIdRouteImport.update({
    id: '/recipes_/duplicate/$recipeId',
    path: '/recipes/duplicate/$recipeId',
    getParentRoute: () => rootRouteImport,
  } as any)
const RecipesRecipeIdPhotosRoute = RecipesRecipeIdPhotosRouteImport.update({
  id: '/recipes_/$recipeId_/photos',
  path: '/recipes/$recipeId/photos',
  getParentRoute: () => rootRouteImport,
} as any)
const IngredientsFcdbIngIdRoute = IngredientsFcdbIngIdRouteImport.update({
  id: '/ingredients_/fcdb_/$ingId',
  path: '/ingredients/fcdb/$ingId',
  getParentRoute: () => rootRouteImport,
} as any)
const IngredientsDisplaynamesNewRoute =
  IngredientsDisplaynamesNewRouteImport.update({
    id: '/ingredients_/displaynames_/new',
    path: '/ingredients/displaynames/new',
    getParentRoute: () => rootRouteImport,
  } as any)
const IngredientsDisplaynamesIngIdRoute =
  IngredientsDisplaynamesIngIdRouteImport.update({
    id: '/ingredients_/displaynames_/$ingId',
    path: '/ingredients/displaynames/$ingId',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/ingredients': typeof IngredientsRouteWithChildren
  '/recipes': typeof RecipesRouteWithChildren
  '/testing': typeof TestingRoute
  '/usage-statistics': typeof UsageStatisticsRouteWithChildren
  '/users': typeof UsersRouteWithChildren
  '/food-restrictions/$restrictionId': typeof FoodRestrictionsRestrictionIdRoute
  '/food-restrictions/new': typeof FoodRestrictionsNewRoute
  '/foodgroups/$groupId': typeof FoodgroupsGroupIdRoute
  '/ingredients/displaynames': typeof IngredientsDisplaynamesRoute
  '/ingredients/fcdb': typeof IngredientsFcdbRoute
  '/recipes/stats': typeof RecipesStatsRoute
  '/recipes/$recipeId': typeof RecipesRecipeIdRoute
  '/recipes/new': typeof RecipesNewRoute
  '/usage-statistics/engagement': typeof UsageStatisticsEngagementRoute
  '/usage-statistics/preferences': typeof UsageStatisticsPreferencesRoute
  '/food-restrictions': typeof FoodRestrictionsIndexRoute
  '/foodgroups': typeof FoodgroupsIndexRoute
  '/meal-simulation': typeof MealSimulationIndexRoute
  '/photos': typeof PhotosIndexRoute
  '/recipes/': typeof RecipesIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/users/': typeof UsersIndexRoute
  '/utils': typeof UtilsIndexRoute
  '/ingredients/displaynames/$ingId': typeof IngredientsDisplaynamesIngIdRoute
  '/ingredients/displaynames/new': typeof IngredientsDisplaynamesNewRoute
  '/ingredients/fcdb/$ingId': typeof IngredientsFcdbIngIdRoute
  '/recipes/$recipeId/photos': typeof RecipesRecipeIdPhotosRoute
  '/recipes/duplicate/$recipeId': typeof RecipesDuplicateRecipeIdRoute
  '/users/$dbcontext/$id': typeof UsersDbcontextIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/ingredients': typeof IngredientsRouteWithChildren
  '/testing': typeof TestingRoute
  '/usage-statistics': typeof UsageStatisticsRouteWithChildren
  '/food-restrictions/$restrictionId': typeof FoodRestrictionsRestrictionIdRoute
  '/food-restrictions/new': typeof FoodRestrictionsNewRoute
  '/foodgroups/$groupId': typeof FoodgroupsGroupIdRoute
  '/ingredients/displaynames': typeof IngredientsDisplaynamesRoute
  '/ingredients/fcdb': typeof IngredientsFcdbRoute
  '/recipes/stats': typeof RecipesStatsRoute
  '/recipes/$recipeId': typeof RecipesRecipeIdRoute
  '/recipes/new': typeof RecipesNewRoute
  '/usage-statistics/engagement': typeof UsageStatisticsEngagementRoute
  '/usage-statistics/preferences': typeof UsageStatisticsPreferencesRoute
  '/food-restrictions': typeof FoodRestrictionsIndexRoute
  '/foodgroups': typeof FoodgroupsIndexRoute
  '/meal-simulation': typeof MealSimulationIndexRoute
  '/photos': typeof PhotosIndexRoute
  '/recipes': typeof RecipesIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/users': typeof UsersIndexRoute
  '/utils': typeof UtilsIndexRoute
  '/ingredients/displaynames/$ingId': typeof IngredientsDisplaynamesIngIdRoute
  '/ingredients/displaynames/new': typeof IngredientsDisplaynamesNewRoute
  '/ingredients/fcdb/$ingId': typeof IngredientsFcdbIngIdRoute
  '/recipes/$recipeId/photos': typeof RecipesRecipeIdPhotosRoute
  '/recipes/duplicate/$recipeId': typeof RecipesDuplicateRecipeIdRoute
  '/users/$dbcontext/$id': typeof UsersDbcontextIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/ingredients': typeof IngredientsRouteWithChildren
  '/recipes': typeof RecipesRouteWithChildren
  '/testing': typeof TestingRoute
  '/usage-statistics': typeof UsageStatisticsRouteWithChildren
  '/users': typeof UsersRouteWithChildren
  '/food-restrictions/$restrictionId': typeof FoodRestrictionsRestrictionIdRoute
  '/food-restrictions/new': typeof FoodRestrictionsNewRoute
  '/foodgroups/$groupId': typeof FoodgroupsGroupIdRoute
  '/ingredients/displaynames': typeof IngredientsDisplaynamesRoute
  '/ingredients/fcdb': typeof IngredientsFcdbRoute
  '/recipes/stats': typeof RecipesStatsRoute
  '/recipes_/$recipeId': typeof RecipesRecipeIdRoute
  '/recipes_/new': typeof RecipesNewRoute
  '/usage-statistics/engagement': typeof UsageStatisticsEngagementRoute
  '/usage-statistics/preferences': typeof UsageStatisticsPreferencesRoute
  '/food-restrictions/': typeof FoodRestrictionsIndexRoute
  '/foodgroups/': typeof FoodgroupsIndexRoute
  '/meal-simulation/': typeof MealSimulationIndexRoute
  '/photos/': typeof PhotosIndexRoute
  '/recipes/': typeof RecipesIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/users/': typeof UsersIndexRoute
  '/utils/': typeof UtilsIndexRoute
  '/ingredients_/displaynames_/$ingId': typeof IngredientsDisplaynamesIngIdRoute
  '/ingredients_/displaynames_/new': typeof IngredientsDisplaynamesNewRoute
  '/ingredients_/fcdb_/$ingId': typeof IngredientsFcdbIngIdRoute
  '/recipes_/$recipeId_/photos': typeof RecipesRecipeIdPhotosRoute
  '/recipes_/duplicate/$recipeId': typeof RecipesDuplicateRecipeIdRoute
  '/users/$dbcontext/$id': typeof UsersDbcontextIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/ingredients'
    | '/recipes'
    | '/testing'
    | '/usage-statistics'
    | '/users'
    | '/food-restrictions/$restrictionId'
    | '/food-restrictions/new'
    | '/foodgroups/$groupId'
    | '/ingredients/displaynames'
    | '/ingredients/fcdb'
    | '/recipes/stats'
    | '/recipes/$recipeId'
    | '/recipes/new'
    | '/usage-statistics/engagement'
    | '/usage-statistics/preferences'
    | '/food-restrictions'
    | '/foodgroups'
    | '/meal-simulation'
    | '/photos'
    | '/recipes/'
    | '/settings'
    | '/users/'
    | '/utils'
    | '/ingredients/displaynames/$ingId'
    | '/ingredients/displaynames/new'
    | '/ingredients/fcdb/$ingId'
    | '/recipes/$recipeId/photos'
    | '/recipes/duplicate/$recipeId'
    | '/users/$dbcontext/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/ingredients'
    | '/testing'
    | '/usage-statistics'
    | '/food-restrictions/$restrictionId'
    | '/food-restrictions/new'
    | '/foodgroups/$groupId'
    | '/ingredients/displaynames'
    | '/ingredients/fcdb'
    | '/recipes/stats'
    | '/recipes/$recipeId'
    | '/recipes/new'
    | '/usage-statistics/engagement'
    | '/usage-statistics/preferences'
    | '/food-restrictions'
    | '/foodgroups'
    | '/meal-simulation'
    | '/photos'
    | '/recipes'
    | '/settings'
    | '/users'
    | '/utils'
    | '/ingredients/displaynames/$ingId'
    | '/ingredients/displaynames/new'
    | '/ingredients/fcdb/$ingId'
    | '/recipes/$recipeId/photos'
    | '/recipes/duplicate/$recipeId'
    | '/users/$dbcontext/$id'
  id:
    | '__root__'
    | '/'
    | '/ingredients'
    | '/recipes'
    | '/testing'
    | '/usage-statistics'
    | '/users'
    | '/food-restrictions/$restrictionId'
    | '/food-restrictions/new'
    | '/foodgroups/$groupId'
    | '/ingredients/displaynames'
    | '/ingredients/fcdb'
    | '/recipes/stats'
    | '/recipes_/$recipeId'
    | '/recipes_/new'
    | '/usage-statistics/engagement'
    | '/usage-statistics/preferences'
    | '/food-restrictions/'
    | '/foodgroups/'
    | '/meal-simulation/'
    | '/photos/'
    | '/recipes/'
    | '/settings/'
    | '/users/'
    | '/utils/'
    | '/ingredients_/displaynames_/$ingId'
    | '/ingredients_/displaynames_/new'
    | '/ingredients_/fcdb_/$ingId'
    | '/recipes_/$recipeId_/photos'
    | '/recipes_/duplicate/$recipeId'
    | '/users/$dbcontext/$id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  IngredientsRoute: typeof IngredientsRouteWithChildren
  RecipesRoute: typeof RecipesRouteWithChildren
  TestingRoute: typeof TestingRoute
  UsageStatisticsRoute: typeof UsageStatisticsRouteWithChildren
  UsersRoute: typeof UsersRouteWithChildren
  FoodRestrictionsRestrictionIdRoute: typeof FoodRestrictionsRestrictionIdRoute
  FoodRestrictionsNewRoute: typeof FoodRestrictionsNewRoute
  FoodgroupsGroupIdRoute: typeof FoodgroupsGroupIdRoute
  RecipesRecipeIdRoute: typeof RecipesRecipeIdRoute
  RecipesNewRoute: typeof RecipesNewRoute
  FoodRestrictionsIndexRoute: typeof FoodRestrictionsIndexRoute
  FoodgroupsIndexRoute: typeof FoodgroupsIndexRoute
  MealSimulationIndexRoute: typeof MealSimulationIndexRoute
  PhotosIndexRoute: typeof PhotosIndexRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
  UtilsIndexRoute: typeof UtilsIndexRoute
  IngredientsDisplaynamesIngIdRoute: typeof IngredientsDisplaynamesIngIdRoute
  IngredientsDisplaynamesNewRoute: typeof IngredientsDisplaynamesNewRoute
  IngredientsFcdbIngIdRoute: typeof IngredientsFcdbIngIdRoute
  RecipesRecipeIdPhotosRoute: typeof RecipesRecipeIdPhotosRoute
  RecipesDuplicateRecipeIdRoute: typeof RecipesDuplicateRecipeIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/users': {
      id: '/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof UsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/usage-statistics': {
      id: '/usage-statistics'
      path: '/usage-statistics'
      fullPath: '/usage-statistics'
      preLoaderRoute: typeof UsageStatisticsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/testing': {
      id: '/testing'
      path: '/testing'
      fullPath: '/testing'
      preLoaderRoute: typeof TestingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/recipes': {
      id: '/recipes'
      path: '/recipes'
      fullPath: '/recipes'
      preLoaderRoute: typeof RecipesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ingredients': {
      id: '/ingredients'
      path: '/ingredients'
      fullPath: '/ingredients'
      preLoaderRoute: typeof IngredientsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/utils/': {
      id: '/utils/'
      path: '/utils'
      fullPath: '/utils'
      preLoaderRoute: typeof UtilsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/': {
      id: '/users/'
      path: '/'
      fullPath: '/users/'
      preLoaderRoute: typeof UsersIndexRouteImport
      parentRoute: typeof UsersRoute
    }
    '/settings/': {
      id: '/settings/'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/recipes/': {
      id: '/recipes/'
      path: '/'
      fullPath: '/recipes/'
      preLoaderRoute: typeof RecipesIndexRouteImport
      parentRoute: typeof RecipesRoute
    }
    '/photos/': {
      id: '/photos/'
      path: '/photos'
      fullPath: '/photos'
      preLoaderRoute: typeof PhotosIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/meal-simulation/': {
      id: '/meal-simulation/'
      path: '/meal-simulation'
      fullPath: '/meal-simulation'
      preLoaderRoute: typeof MealSimulationIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/foodgroups/': {
      id: '/foodgroups/'
      path: '/foodgroups'
      fullPath: '/foodgroups'
      preLoaderRoute: typeof FoodgroupsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/food-restrictions/': {
      id: '/food-restrictions/'
      path: '/food-restrictions'
      fullPath: '/food-restrictions'
      preLoaderRoute: typeof FoodRestrictionsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/usage-statistics/preferences': {
      id: '/usage-statistics/preferences'
      path: '/preferences'
      fullPath: '/usage-statistics/preferences'
      preLoaderRoute: typeof UsageStatisticsPreferencesRouteImport
      parentRoute: typeof UsageStatisticsRoute
    }
    '/usage-statistics/engagement': {
      id: '/usage-statistics/engagement'
      path: '/engagement'
      fullPath: '/usage-statistics/engagement'
      preLoaderRoute: typeof UsageStatisticsEngagementRouteImport
      parentRoute: typeof UsageStatisticsRoute
    }
    '/recipes_/new': {
      id: '/recipes_/new'
      path: '/recipes/new'
      fullPath: '/recipes/new'
      preLoaderRoute: typeof RecipesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/recipes_/$recipeId': {
      id: '/recipes_/$recipeId'
      path: '/recipes/$recipeId'
      fullPath: '/recipes/$recipeId'
      preLoaderRoute: typeof RecipesRecipeIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/recipes/stats': {
      id: '/recipes/stats'
      path: '/stats'
      fullPath: '/recipes/stats'
      preLoaderRoute: typeof RecipesStatsRouteImport
      parentRoute: typeof RecipesRoute
    }
    '/ingredients/fcdb': {
      id: '/ingredients/fcdb'
      path: '/fcdb'
      fullPath: '/ingredients/fcdb'
      preLoaderRoute: typeof IngredientsFcdbRouteImport
      parentRoute: typeof IngredientsRoute
    }
    '/ingredients/displaynames': {
      id: '/ingredients/displaynames'
      path: '/displaynames'
      fullPath: '/ingredients/displaynames'
      preLoaderRoute: typeof IngredientsDisplaynamesRouteImport
      parentRoute: typeof IngredientsRoute
    }
    '/foodgroups/$groupId': {
      id: '/foodgroups/$groupId'
      path: '/foodgroups/$groupId'
      fullPath: '/foodgroups/$groupId'
      preLoaderRoute: typeof FoodgroupsGroupIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/food-restrictions/new': {
      id: '/food-restrictions/new'
      path: '/food-restrictions/new'
      fullPath: '/food-restrictions/new'
      preLoaderRoute: typeof FoodRestrictionsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/food-restrictions/$restrictionId': {
      id: '/food-restrictions/$restrictionId'
      path: '/food-restrictions/$restrictionId'
      fullPath: '/food-restrictions/$restrictionId'
      preLoaderRoute: typeof FoodRestrictionsRestrictionIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/$dbcontext/$id': {
      id: '/users/$dbcontext/$id'
      path: '/$dbcontext/$id'
      fullPath: '/users/$dbcontext/$id'
      preLoaderRoute: typeof UsersDbcontextIdRouteImport
      parentRoute: typeof UsersRoute
    }
    '/recipes_/duplicate/$recipeId': {
      id: '/recipes_/duplicate/$recipeId'
      path: '/recipes/duplicate/$recipeId'
      fullPath: '/recipes/duplicate/$recipeId'
      preLoaderRoute: typeof RecipesDuplicateRecipeIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/recipes_/$recipeId_/photos': {
      id: '/recipes_/$recipeId_/photos'
      path: '/recipes/$recipeId/photos'
      fullPath: '/recipes/$recipeId/photos'
      preLoaderRoute: typeof RecipesRecipeIdPhotosRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ingredients_/fcdb_/$ingId': {
      id: '/ingredients_/fcdb_/$ingId'
      path: '/ingredients/fcdb/$ingId'
      fullPath: '/ingredients/fcdb/$ingId'
      preLoaderRoute: typeof IngredientsFcdbIngIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ingredients_/displaynames_/new': {
      id: '/ingredients_/displaynames_/new'
      path: '/ingredients/displaynames/new'
      fullPath: '/ingredients/displaynames/new'
      preLoaderRoute: typeof IngredientsDisplaynamesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ingredients_/displaynames_/$ingId': {
      id: '/ingredients_/displaynames_/$ingId'
      path: '/ingredients/displaynames/$ingId'
      fullPath: '/ingredients/displaynames/$ingId'
      preLoaderRoute: typeof IngredientsDisplaynamesIngIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface IngredientsRouteChildren {
  IngredientsDisplaynamesRoute: typeof IngredientsDisplaynamesRoute
  IngredientsFcdbRoute: typeof IngredientsFcdbRoute
}

const IngredientsRouteChildren: IngredientsRouteChildren = {
  IngredientsDisplaynamesRoute: IngredientsDisplaynamesRoute,
  IngredientsFcdbRoute: IngredientsFcdbRoute,
}

const IngredientsRouteWithChildren = IngredientsRoute._addFileChildren(
  IngredientsRouteChildren,
)

interface RecipesRouteChildren {
  RecipesStatsRoute: typeof RecipesStatsRoute
  RecipesIndexRoute: typeof RecipesIndexRoute
}

const RecipesRouteChildren: RecipesRouteChildren = {
  RecipesStatsRoute: RecipesStatsRoute,
  RecipesIndexRoute: RecipesIndexRoute,
}

const RecipesRouteWithChildren =
  RecipesRoute._addFileChildren(RecipesRouteChildren)

interface UsageStatisticsRouteChildren {
  UsageStatisticsEngagementRoute: typeof UsageStatisticsEngagementRoute
  UsageStatisticsPreferencesRoute: typeof UsageStatisticsPreferencesRoute
}

const UsageStatisticsRouteChildren: UsageStatisticsRouteChildren = {
  UsageStatisticsEngagementRoute: UsageStatisticsEngagementRoute,
  UsageStatisticsPreferencesRoute: UsageStatisticsPreferencesRoute,
}

const UsageStatisticsRouteWithChildren = UsageStatisticsRoute._addFileChildren(
  UsageStatisticsRouteChildren,
)

interface UsersRouteChildren {
  UsersIndexRoute: typeof UsersIndexRoute
  UsersDbcontextIdRoute: typeof UsersDbcontextIdRoute
}

const UsersRouteChildren: UsersRouteChildren = {
  UsersIndexRoute: UsersIndexRoute,
  UsersDbcontextIdRoute: UsersDbcontextIdRoute,
}

const UsersRouteWithChildren = UsersRoute._addFileChildren(UsersRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  IngredientsRoute: IngredientsRouteWithChildren,
  RecipesRoute: RecipesRouteWithChildren,
  TestingRoute: TestingRoute,
  UsageStatisticsRoute: UsageStatisticsRouteWithChildren,
  UsersRoute: UsersRouteWithChildren,
  FoodRestrictionsRestrictionIdRoute: FoodRestrictionsRestrictionIdRoute,
  FoodRestrictionsNewRoute: FoodRestrictionsNewRoute,
  FoodgroupsGroupIdRoute: FoodgroupsGroupIdRoute,
  RecipesRecipeIdRoute: RecipesRecipeIdRoute,
  RecipesNewRoute: RecipesNewRoute,
  FoodRestrictionsIndexRoute: FoodRestrictionsIndexRoute,
  FoodgroupsIndexRoute: FoodgroupsIndexRoute,
  MealSimulationIndexRoute: MealSimulationIndexRoute,
  PhotosIndexRoute: PhotosIndexRoute,
  SettingsIndexRoute: SettingsIndexRoute,
  UtilsIndexRoute: UtilsIndexRoute,
  IngredientsDisplaynamesIngIdRoute: IngredientsDisplaynamesIngIdRoute,
  IngredientsDisplaynamesNewRoute: IngredientsDisplaynamesNewRoute,
  IngredientsFcdbIngIdRoute: IngredientsFcdbIngIdRoute,
  RecipesRecipeIdPhotosRoute: RecipesRecipeIdPhotosRoute,
  RecipesDuplicateRecipeIdRoute: RecipesDuplicateRecipeIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
